// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__1Zwua","content":"GlobalSearch_content__16L4c"};